import {Component, effect, inject, signal} from '@angular/core';
import {ActionButtonComponent} from "src/app/presentation/common/action-button/action-button.component";
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {Asset, Device} from "src/app/infrastructure/moovement-api/models/asset";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {BootstrapService} from 'src/app/infrastructure/init/bootstrap.service';
import {NetworkStatusStore} from 'src/app/infrastructure/network/network-status.store';
import {NavBarStateStore} from 'src/app/presentation/main-view/nav-bar/nav-bar-state/nav-bar-state.store';
import {Router} from '@angular/router';
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';
import {AssetsStore} from 'src/app/domain/assets/assets.store';
import {DeviceStore} from 'src/app/domain/devices/device.store';
import {DeviceAssociationStore} from 'src/app/domain/devices/device-association.store';

@Component({
  selector: 'app-search-bar',
  imports: [
    ActionButtonComponent,
    GenericButtonComponent
  ],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.css'
})
export class SearchBarComponent {

  disabled = signal(false);
  loading = signal(false);
  filteredAssets = signal<Asset[]>([]);
  filteredDevices = signal<Device[]>([]);
  showResults = signal(false);

  networkStatusStore = inject(NetworkStatusStore);

  private assetsStore = inject(AssetsStore);
  private deviceStore = inject(DeviceStore);
  private deviceAssociationStore = inject(DeviceAssociationStore);
  private mainViewStore = inject(MainViewStore);
  private menuStore = inject(NavBarStateStore);
  private router = inject(Router);

  constructor(
      private bootstrapService: BootstrapService,
      private dataSubscriptionService: DataSubscriptionService,
      private viewportService: ViewportService
  ) {
    this.viewportService.checkViewportSize();

    effect(() => {
      this.disabled.set(this.loading() || !this.menuStore.enabled());
    });

    effect(() => {
      this.loading.set(this.assetsStore.loading() || this.deviceStore.loading() || this.deviceAssociationStore.loading());
    });
  }

  search(target: any) {
    const value = target?.value;
    const assets = this.assetsStore.assets();
    const devices = this.deviceStore.entities();

    if (value) {
      const subject = (value as string).toLocaleLowerCase();

      const filteredAssets = assets.filter((asset) =>
        asset.name?.toLocaleLowerCase().includes(subject) || asset.id?.toLocaleLowerCase().includes(subject));
      this.filteredAssets.set(filteredAssets);

      const filteredDevices = devices.filter((device) =>
        device.name?.toLocaleLowerCase().includes(subject) || device.id?.toLocaleLowerCase().includes(subject));
      this.filteredDevices.set(filteredDevices);

      this.showResults.set(true);
    } else {
      this.showResults.set(false);
    }
  }

  selectAsset(asset: Asset) {
    this.showResults.set(false);
    this.navigateToAsset(asset.id);
  }

  selectDevice(device: Device) {
    this.showResults.set(false);

    const assetId = this.deviceAssociationStore.deviceIdToAssetId().get(device.id);
    this.navigateToAsset(assetId);
  }

  private navigateToAsset(assetId?: string) {
    if (!assetId) return;

    const url = this.assetsStore.assetIdToUrl(assetId);
    if (!url) return;

    this.mainViewStore.showChildComponent();
    this.router.navigate([url, assetId]);
  }

  resetView() {
    this.dataSubscriptionService.publish('resetView', "")
  }

  refresh() {
    if (!this.networkStatusStore.isOnline()) return;
    this.bootstrapService.refresh();
  }

  focus() {
    this.showResults.set(true);
  }

  blur() {
    // The delay is required to be able to handle click events on the search results
    setTimeout(() => this.showResults.set(false), 100);
  }
}
